// extracted by mini-css-extract-plugin
export var container = "_77-0";
export var infoButton = "_77-1";
export var label = "_77-3";
export var labelExpanded = "_77-4";
export var price = "_77-5";
export var priceExpanded = "_77-6";
export var title = "_77-2";